import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cloudX')
  .controller('FiscalLoanDialog', [
    '$http',
    'appUrls',
    'flySvc',
    'checkSecurity',
    '$element',
    'close',
    'relationId',
    'data',
    'documents',
    fiscalLoanDialog,
  ]);

function fiscalLoanDialog(
  $http,
  appUrls,
  flySvc,
  checkSecurity,
  $element,
  close,
  relationId,
  data,
  documents,
) {
  var vm = this;
  vm.saving = false;
  vm.readOnly = !checkSecurity('Relation:u');
  vm.showValidation = false;
  vm.datepickerOptions = {
    startingDay: 1,
    initDate: moment
      .utc()
      .startOf('day')
      .toDate(),
  };
  vm.relationId = relationId;
  vm.documentsAccessor = {};
  vm.documentLinkType = 9;
  vm.documents = [...(documents || [])];
  vm.documentsChanged = false;
  vm.onDocumentsChanged = function() {
    vm.documentsChanged = true;
  };
  vm.loan = angular.extend(
    {
      relationId: relationId,
      creditInstitution: null,
      reference: null,
      amount: null,
      startDate: null,
      endDate: null,
      purpose: null,
      repaymentAmount: null,
      repaymentMonths: null,
      remark: null,
    },
    data,
  );

  vm.save = function() {
    if (vm.form.$invalid) return '';
    if (vm.saving) return '';

    vm.saving = true;
    $http.post(`${appUrls.api}/api/Fiscal/Loan`, vm.loan).then(
      function({ data }) {
        if (typeof data.startDate === 'string')
          data.startDate = moment.utc(data.startDate.substr(0, 10)).toDate();
        if (typeof data.endDate === 'string')
          data.endDate = moment.utc(data.endDate.substr(0, 10)).toDate();
        if (data.id) {
          vm.loan.id = data.id;
          if (vm.documentsAccessor && vm.documentsAccessor.uploadNewDocuments) {
            return vm.documentsAccessor.uploadNewDocuments(data.id).then(changed => {
              vm.saving = false;
              flySvc.success();

              close([data, changed || vm.documentsChanged ? vm.documents : null], 500);
              $element.modal('hide');
            });
          }
        }

        vm.saving = false;
        flySvc.success();
        close([data, vm.documentsChanged ? vm.documents : null], 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };
  vm.cancel = function() {
    close([null, vm.documentsChanged ? vm.documents : null], 500);
  };
}
